import {
  useTranslation,
  type TranslationKeys,
} from "@/hooks/useTranslation/useTranslation"
import { cn } from "@/lib/utils"
import { Link } from "react-router"
import { formatInt, localeForLanguage } from "../customerDashboardStore"

/**
 * Shared row shell behind the Gaps/Conformity widgets' summary rows — a
 * label + count that deep-links to a filtered list, with an optional warn
 * tint when the count is above zero.
 */
export function SummaryLinkRow({
  labelKey,
  value,
  to,
  warn,
}: {
  labelKey: TranslationKeys
  value: number
  to: string
  warn?: boolean
}) {
  const { translate, currentLanguage } = useTranslation()
  const locale = localeForLanguage(currentLanguage)
  const isWarn = !!warn && value > 0

  return (
    <Link
      to={to}
      className={cn(
        "-mx-1 flex items-baseline justify-between gap-4 rounded-sm border-t border-white/5 px-1 py-3 text-sm text-grey5 transition-colors first:border-t-0 hover:bg-white/3 hover:text-white focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-ring",
        isWarn && "text-warning hover:text-warning",
      )}
    >
      <span>{translate(labelKey)}</span>
      <b
        className={cn(
          "font-semibold tabular-nums text-white",
          isWarn && "text-warning",
        )}
      >
        {formatInt(value, locale)}
      </b>
    </Link>
  )
}
